import { Tab, TabsComponent } from '@components';
import { FeatureFlags } from '@constants/featureFlags';
import { customerDetailsStore } from '@store/customers/customerDetails';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { userStore } from '@store/user';
import { createSignal } from 'solid-js';

import { AddressBookTab } from '../../addressBookTab';
import { ClaimHistory } from '../../claimHistory';
import { Collections } from '../../collections';
import { Contracts } from '../../contracts';
import EDI from '../../edi';
import { EditHistory } from '../../editHistory';
import { Financials } from '../../financials';
import { FuelSurcharge } from '../../fuelSurcharge';
import { General } from '../../general';
import { Ltl } from '../../ltl';
import { LtlSavedQuotes } from '../../ltlSavedQuotes';
import { OrderHistory } from '../../orderHistory';
import { PaymentHistory } from '../../paymentHistory';
import { Pricing } from '../../pricing';
import { CustomerProductCatalog } from '../../productCatalog';
import { Quotes } from '../../quotes';
import CarrierRestrictions from '../../carrierRestrictions';

const TAB_COMPONENTS = {
  GENERAL: General,
  FINANCIALS: Financials,
  QUOTES: () => <Quotes type="Customer" />,
  LTL: Ltl,
  'LTL SAVED QUOTES': LtlSavedQuotes,
  'PRODUCT CATALOG': CustomerProductCatalog,
  'ADDRESS BOOK': AddressBookTab,
  'FUEL SURCHARGE': () => (
    <FuelSurcharge id={customerDetailsStore.customer.id as number} type="0" />
  ),
  EDI,
  COLLECTIONS: Collections,
  'ORDER HISTORY': OrderHistory,
  'CLAIM HISTORY': ClaimHistory,
  'CARRIER RESTRICTIONS': CarrierRestrictions,
  'PAYMENT HISTORY': PaymentHistory,
  'EDIT HISTORY': EditHistory,
  PRICING: Pricing,
  CONTRACTS: Contracts,
};

const CustomerDetailTabPanel = () => {
  const [activeTab, setActiveTab] = createSignal(0);

  const basicTabs = Object.keys(TAB_COMPONENTS);
  const filteredTabs = () => {
    const tabs = Boolean(userStore.user.permissions?.includes('Rate LTL'))
      ? basicTabs
      : basicTabs.filter(
          (tab) =>
            !['LTL', 'LTL SAVED QUOTES', 'PRODUCT CATALOG'].includes(tab),
        );
    return isFeatureFlagEnabled(FeatureFlags.CarrierRestrictionsTab)()
      ? tabs
      : tabs.filter((tab) => tab !== 'CARRIER RESTRICTIONS');
  };

  const renderActiveTabContent = () => {
    const tabKey = filteredTabs()[activeTab()];
    const TabContent =
      tabKey && TAB_COMPONENTS[tabKey as keyof typeof TAB_COMPONENTS];
    if (!TabContent) {
      return null;
    }
    return <TabContent />;
  };

  return (
    <>
      <TabsComponent
        border
        tabStyleClasses="rounded-t-lg"
        tabContainerStyles="ml-4 items-center w-0!"
        activeStyling="bg-[#ffe8b7]"
        showChevrons
        tabs={filteredTabs().map((tab) => (
          <Tab>{tab}</Tab>
        ))}
        activeTab={activeTab()}
        onTabClick={setActiveTab}
      />
      <div class="border-t border-gray-300 mb-2 ml-4" />
      {renderActiveTabContent()}
    </>
  );
};

export default CustomerDetailTabPanel;
